<template>
  <div class="headerTop">
    <div class="topLeft" style="margin-left:6.197vw;width:8vw;">欢迎登录武夷山景区!</div>
    <div class="topLeft" style="width:8vw">今天是：{{ nowTime }}</div>
    <div class="topLeft" style="width:3vw">{{ nowDay }}</div>
    <img src="@/assets/image/gongao.png" class="topImg" />
    <!-- <div class="topRight" style="margin-left:11px">{{ topNotice }}</div> -->
    <HeadTopNotice class="topRight" style="margin-left:0.3vw" @handleOpen="handleOpen"> </HeadTopNotice>
    <img src="@/assets/image/phone.png" class="topImgB" />
    <div class="right">
      <div class="topRightPhone">0599-5135110</div>
      <div class="topRightTime">08:00-18:00</div>
    </div>
    <div class="topEnglish" @click="changeEnglish">English</div>
  </div>
</template>

<script>
import HeadTopNotice from "@/components/common/headTopNotice.vue";
export default {
  name: "HeadTop",
  components: { HeadTopNotice },
  data() {
    return {
      nowTime: "",
      nowDay: ""
    };
  },
  mounted() {
    this.getNowTimeFormat();
  },
  methods: {
    handleOpen(data) {
      this.$emit('handleOpen', data)
    },
    //时间获取
    getNowTimeFormat() {
      var myDate = new Date();
      let month = myDate.getMonth() + 1;
      let strDate = myDate.getDate();
      let days = myDate.getDay();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      this.nowTime = `${myDate.getFullYear()}年${month}月${strDate}日`;
      this.nowDay = this.getNowDays(days);
    },
    //星期转换
    getNowDays(days) {
      switch (days) {
        case 1:
          days = "星期一";
          break;
        case 2:
          days = "星期二";
          break;
        case 3:
          days = "星期三";
          break;
        case 4:
          days = "星期四";
          break;
        case 5:
          days = "星期五";
          break;
        case 6:
          days = "星期六";
          break;
        case 0:
          days = "星期日";
          break;
      }
      return days;
    },
    changeEnglish() {
      let toUrl = window.location.origin;
      window.location.href = `${toUrl}/en`;
    }
  }
};
</script>

<style scoped>
.headerTop {
  display: flex;
  flex-direction: row;
  max-width: 1920px;
  height: 5.55vh;
  background: #4a9183;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.34);
  margin: auto;
}
.headerTop .topLeft {
  font-size: 1.111vh;
  font-weight: 400;
  color: #ffffff;
  line-height: 5.55vh;
}
.headerTop .topRight {
  font-size: 1.111vh;
  font-weight: 400;
  color: #ffffff;
  line-height: 5.55vh;
  width: 36.71%;
  text-overflow: ellipsis;
  /* text-overflow:ellipsis;//超出文本隐藏 */
  overflow: hidden;
  white-space: nowrap;
}
.headerTop .topImg {
  width: 2.08vw;
  height: 1.9444vh;
  margin-top: 1.574vh;
  margin-left: 10%;
}
.headerTop .topImgB {
  width: 3.055vh;
  height: 3.055vh;
  margin-top: 1.2962vh;
  margin-left: 10%;
}
.headerTop .topRightPhone {
  font-size: 2.037vh;
  height: 1.4814vh;
  /* 不换行 */
  white-space: nowrap;
  font-family: Arial;
  font-weight: bold;
  font-style: italic;
  color: #ffffff;
}
.headerTop .topRightTime {
  font-size: 1.2962vh;
  font-family: "Microsoft YaHei";
  height: 1.2962vh;
  font-weight: 400;
  font-style: italic;
  color: #ffffff;
  margin-top: 0.5555vh;
}
.headerTop .right {
  display: flex;
  flex-direction: column;
  margin-left: 0.3125vw;
  margin-top: 1.1111vh;
}
.headerTop .topEnglish {
  width: 3.28125vw;
  height: 2.22vh;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 1.1111vh;
  color: #449088;
  text-align: center;
  line-height: 2.22vh;
  margin-left: 2.34375vw;
  margin-top: 1.66667vh;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headTop.vue